module.exports = __webpack_public_path__ + "img/妇温宝.48737451.png";